import { set, get } from "lodash";
export default function removeAuthHeader(config) {
    if (get(config, "headers.Authorization")) {
        set(config, "headers.Authorization", "<redacted>");
    }
}
